/* eslint-disable import/extensions,import/no-unresolved,import/no-unresolved,import/no-duplicates,import/no-named-as-default-member,no-constant-condition,no-console */
/**
 * Gets the repositories of the user from Github
 */
import _, { take } from 'lodash';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import apiConfig from 'utils/apiConfig';
import { combineDateTime } from 'utils/dateUtil';
import { startProgress, endProgress } from 'containers/ProgressBar/actions';
import { setClaimTypes, setChildBenefits, getInitClaimTypeSuccess } from 'containers/App/actions';
import { mapCountryList, mapCityList, mapNewFormatCountryList } from '../dataMapper/countryMapper';
import {
  GET_CITY_LIST,
  GET_COUNTRY_LIST,
  GET_COUNTRY_SUPPORTED_LIST,
  GET_CLAIM_TYPES,
  VALIDATE_DATE_TIME_OF_EVENT,
} from './constants';
import {
  getCityListSuccess,
  getCountryListSuccess,
  getCountriesOfxSupportedSuccess,
  handleFormDataChange,
  getClaimTypeSuccess,
  policyVersionChanged,
} from './actions';
import { makeSelectAuthToken } from '../../Login/selectors';
import { makeSelectStepWhatHappened, makeSelectOldEventDate } from './selectors';
import { makeError } from '../../Wizard/actions';
import { makeSelectPolicyId, makeSelectJSONVersion, makeSelectShowZurichUHC, makeSelectPolicyTypeCode } from '../../App/selectors';
import { makeSelectPolicyTypeId, makeSelectClaimId } from '../../ClaimList/selectors';
import {
  logoutSuccess,
  setErrorMessageDateValidation,
} from '../../App/actions';
import isAuthorised from '../../../utils/unauthoriseValidator';
import { resetLoginInfo } from '../../Login/actions';
import { showErrorToastr } from '../../Toastr/actions';

export function* getCountries() {
  // yield put(startProgress());
  // TODO call API to get countries
  try {
    const token = yield select(makeSelectAuthToken());
    const authToken = `bearer ${token}`;
    const requestUrl = `${apiConfig.restServiceDomain}/api/v1/Countries`;
    const jsonVersion = yield select(makeSelectJSONVersion());
    const newVersion = jsonVersion > 9;
    const requestOption = {
      method: 'GET',
      headers: {
        Authorization: authToken,
        'Content-Type': 'application/json',
      },
    };
    const response = yield call(request, requestUrl, requestOption);
    if (response.isSuccess) {
      const rs = newVersion ? mapNewFormatCountryList(response.payload) : mapCountryList(response.payload);
      // set data for country list
      yield put(getCountryListSuccess(rs));
      // reset country, city field if old data
      const stepWhatHappenedData = yield select(makeSelectStepWhatHappened());
      const isCountryFieldValid = _.find(rs, (d) => d.id === stepWhatHappenedData.country);
      if (!isCountryFieldValid && !!stepWhatHappenedData.country) {
        yield put(handleFormDataChange('form.country', ''));
        yield put(handleFormDataChange('form.city', ''));
        yield put(makeError(3));
      }
    }
  } catch (e) {
    console.log(e);
  } finally {
    // yield put(endProgress());
  }
}

export function* getCountriesOfxSupported() {
  // yield put(startProgress());
  // TODO call API to get countries
  try {
    const token = yield select(makeSelectAuthToken());
    const authToken = `bearer ${token}`;
    const requestUrl = `${apiConfig.restServiceDomain}/api/v1/countriesOfxSupported`;
    const jsonVersion = yield select(makeSelectJSONVersion());
    const newVersion = jsonVersion > 9;
    const requestOption = {
      method: 'GET',
      headers: {
        Authorization: authToken,
        'Content-Type': 'application/json',
      },
    };
    const response = yield call(request, requestUrl, requestOption);
    if (response.isSuccess) {
      const rs = newVersion ? mapNewFormatCountryList(response.payload) : mapCountryList(response.payload);
      // set data for country list
      yield put(getCountriesOfxSupportedSuccess(rs));
    }
  } catch (e) {
    console.log(e);
  } finally {
    // yield put(endProgress());
  }
}

export function* getCities({ stringCity, callback }) {
  // yield put(startProgress());
  // TODO call API to get cities
  try {
    const stepWhatHappenedData = yield select(makeSelectStepWhatHappened());
    const selectedCountry = stepWhatHappenedData.selectedCountry;
    let country = !!selectedCountry && typeof selectedCountry.toJS === 'function' ? selectedCountry.toJS() : selectedCountry;
    if (!country || typeof country !== 'object' || !country.id) {
      country = { id: 0 };
    }
    const token = yield select(makeSelectAuthToken());
    const authToken = `bearer ${token}`;
    const requestUrl = `${apiConfig.restServiceDomain
      }/api/v1/Countries/Cities?countryID=${country.id}&cityName=${stringCity || ''
      }`;
    const requestOption = {
      method: 'GET',
      headers: {
        Authorization: authToken,
        'Content-Type': 'application/json',
      },
    };
    const response = yield call(request, requestUrl, requestOption);
    if (response.isSuccess) {
      const rs = mapCityList(response.payload);
      yield put(getCityListSuccess(rs));
      if (callback) {
        callback(rs);
      }
    }
  } catch (e) {
    console.log(e);
  } finally {
    // yield put(endProgress());
  }
}

function* loadClaimTypeList(byClaimId) {
  const token = yield select(makeSelectAuthToken());
  const policyId = yield select(makeSelectPolicyId());
  const claimId = yield select(makeSelectClaimId());
  const stepWhatHappenedData = yield select(makeSelectStepWhatHappened());
  const { dateOfEvent, timeOfEvent } = stepWhatHappenedData;
  if (!byClaimId && (!dateOfEvent || !timeOfEvent)) {
    return;
  }
  const incidentDate = combineDateTime(dateOfEvent, timeOfEvent);
  const requestURL = (byClaimId) ?
    `${apiConfig.restServiceDomain}/api/v1/policies/${policyId}/claimTypes?claimParentId=${claimId}` :
    `${apiConfig.restServiceDomain}/api/v1/policies/${policyId}/claimTypes?incidentDate=${incidentDate}`;

  const requestOptions = {
    headers: {
      Authorization: `bearer ${token}`,
    },
  };

  try {
    yield put(startProgress());
    const res = yield call(request, requestURL, requestOptions);
    const policyTypeId = yield select(makeSelectPolicyTypeId());
    const policyTypeCode = yield select(makeSelectPolicyTypeCode());
    const jsonVersion = yield select(makeSelectJSONVersion());
    const showZurichUHC = yield select(makeSelectShowZurichUHC());
    yield put(setClaimTypes([...res.payload.claimTypeDtos], policyTypeId));
    yield put(setChildBenefits([...res.payload.childBenefitDtos], policyTypeId));
    yield put(
      getClaimTypeSuccess({ claimTypeList: res.payload.claimTypeDtos, policyTypeId, jsonVersion, showZurichUHC, policyTypeCode })
    );
    yield put(
      getInitClaimTypeSuccess({ claimTypeList: res.payload.claimTypeDtos })
    );
  } catch (err) {
    if (!isAuthorised(err.response)) {
      yield put(resetLoginInfo());
      yield put(logoutSuccess());
    } else {
      yield put(showErrorToastr(err.message));
    }
  } finally {
    yield put(endProgress());
  }
}

function* validateEventDateTime({ fieldName }) {
  try {
    yield put(startProgress());
    const token = yield select(makeSelectAuthToken());
    const policyId = yield select(makeSelectPolicyId());
    const stepWhatHappenedData = yield select(makeSelectStepWhatHappened());
    const { dateOfEvent, timeOfEvent } = stepWhatHappenedData;
    if (!dateOfEvent || !timeOfEvent) {
      return;
    }
    const incidentDate = combineDateTime(dateOfEvent, timeOfEvent);
    const data = { incidentDate };
    const requestUrl = `${apiConfig.restServiceDomain}/api/v1/policies/${policyId}/claims/validateIncidentDate`;
    const requestOption = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `bearer ${token}`,
      },
      method: 'POST',
      body: JSON.stringify(data),
    };
    const response = yield call(request, requestUrl, requestOption);
    if (response.isSuccess) {
      if (!response.payload.isValid) {
        // yield put(handleFormDataChange(fieldName, null));
        // yield put(handleFormDataChange('form.selectedBenefits', []));
        yield put(setErrorMessageDateValidation('Date of Event selected is not within the Policy cover period. Proceed anyway?'));
      } else {
        yield put(setErrorMessageDateValidation(''));
        // yield loadClaimTypeList();
        yield validatePolicyVersionChange();
      }
    }
  } catch (err) {
    if (!isAuthorised(err.response)) {
      yield put(resetLoginInfo());
      yield put(logoutSuccess());
    } else {
      yield put(showErrorToastr(err.message));
    }
  } finally {
    yield put(endProgress());
  }
}

function* validatePolicyVersionChange() {
  const token = yield select(makeSelectAuthToken());
  const policyId = yield select(makeSelectPolicyId());
  const stepWhatHappenedData = yield select(makeSelectStepWhatHappened());
  const { dateOfEvent, timeOfEvent } = stepWhatHappenedData;
  if (!dateOfEvent || !timeOfEvent) {
    return;
  }
  const newIncidentDate = combineDateTime(dateOfEvent, timeOfEvent);
  const { oldEventDate, oldEventTime } = yield select(makeSelectOldEventDate());
  const incidentDate = combineDateTime(oldEventDate, oldEventTime);
  const data = {
    incidentDate,
    newIncidentDate,
  };
  const requestUrl = `${apiConfig.restServiceDomain}/api/v1/policies/${policyId}/validatePolicyVersionChange`;
  const requestOption = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `bearer ${token}`,
    },
    body: JSON.stringify(data),
  };

  try {
    yield put(startProgress());
    const response = yield call(request, requestUrl, requestOption);
    if (response.isSuccess) {
      if (response.payload.isPolicyVersionChange) {
        // show warning
        yield put(policyVersionChanged(true));
      } else {
        yield put(handleFormDataChange('oldEventDate', dateOfEvent));
        yield put(handleFormDataChange('oldEventTime', timeOfEvent));
        yield loadClaimTypeList();
      }
    }
  } catch (err) {
    if (!isAuthorised(err.response)) {
      yield put(resetLoginInfo());
      yield put(logoutSuccess());
    } else {
      yield put(showErrorToastr(err.message));
    }
  } finally {
    yield put(endProgress());
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function* stepWhatHappened() {
  yield [
    takeLatest(GET_COUNTRY_LIST, getCountries),
    takeLatest(GET_COUNTRY_SUPPORTED_LIST, getCountriesOfxSupported),
    takeLatest(GET_CITY_LIST, getCities),
    takeLatest(GET_CLAIM_TYPES, loadClaimTypeList),
    takeLatest(VALIDATE_DATE_TIME_OF_EVENT, validateEventDateTime),
  ];
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepWhatHappened/saga.js